import { render } from "./ApplicationsManagement.vue?vue&type=template&id=628d5d55&ts=true"
import script from "./ApplicationsManagement.vue?vue&type=script&lang=ts"
export * from "./ApplicationsManagement.vue?vue&type=script&lang=ts"

import "./ApplicationsManagement.vue?vue&type=style&index=0&id=628d5d55&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__